export default {
  barTitle: 'Файлы cookie',
  barDescription: 'Мы используем наши собственные файлы cookie и сторонние файлы cookie, чтобы мы могли показать вам этот веб-сайт и лучше понять, как вы его используете, с целью улучшения предлагаемых нами услуг. Если вы продолжите просмотр, мы будем считать, что вы приняли файлы cookie.',
  acceptAll: 'Принять все',
  declineAll: 'Удалить все',
  manageCookies: 'Управление файлами cookie',
  unsaved: 'У вас есть несохраненные настройки',
  close: 'Закрыть',
  save: 'Сохранить',
  necessary: 'Необходимые файлы cookie',
  optional: 'Дополнительные файлы cookie',
  functional: 'Функциональные файлы cookie',
  blockedIframe: 'Чтобы это увидеть, включите функциональные файлы cookie',
  here: 'здесь'
}
